exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".set-field{overflow-wrap:anywhere;font-size:14px}.set-field:hover{background:rgba(0,0,0,.04)}.set-time{display:block;text-align:left}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/common/ItemsField.vue"],"names":[],"mappings":"AACA,WACE,uBAAwB,AACxB,cAAgB,CACjB,AACD,iBACE,0BAAgC,CACjC,AACD,UACE,cAAe,AACf,eAAiB,CAClB","file":"ItemsField.vue","sourcesContent":["\n.set-field {\n  overflow-wrap: anywhere;\n  font-size: 14px;\n}\n.set-field:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n.set-time {\n  display: block;\n  text-align: left;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52fe7616","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/ItemsField.vue
// module id = 837
// module chunks = 1